import React from 'react';

const ClinicalActivityIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 4.4375V15.9375C3 16.7281 3.64687 17.375 4.4375 17.375H20.25C21.0406 17.375 21.6875 16.7281 21.6875 15.9375V4.4375C21.6875 3.64687 21.0406 3 20.25 3H4.4375C3.64687 3 3 3.64687 3 4.4375Z"
      stroke="#2C2543"
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.3125 21.6875H17.375"
      stroke="#2C2543"
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.1875 17.375C10.1875 18.8844 9.68442 20.6813 8.8938 21.6875"
      stroke="#2C2543"
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.7937 21.6875C15.0031 20.6813 14.5 18.8844 14.5 17.375"
      stroke="#2C2543"
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.875 10.1875H9.46875L10.9062 8.75L12.3438 11.625L13.7812 8.03125L15.2188 10.1875H18.8125"
      stroke="#2C2543"
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ClinicalActivityIcon;
